import { useContext } from 'react';
import { FedopsLoggerContext } from './FedopsLoggerProvider';
export var useFedopsLogger = function () { return useContext(FedopsLoggerContext); };
//# sourceMappingURL=useFedopsLogger.js.map